import React from "react";
import { Tab, Tabs } from "@material-ui/core";
import PropTypes from "prop-types";

/**
 *
 * @param options
 * @param onChange Funktion, welche das Label der ausgewählten Komponente als Variable bekommt
 * @param value Das aktuell dargestellte Element
 * @param optionLabels
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
function EATabs({ options, onChange, value, optionLabels = {}, ...rest }) {
    function handleTabChange(e, newValue) {
        onChange(options[newValue]);
    }

    function createOption(option) {
        const style = {};
        if (rest.errors && rest.errors[option]) {
            style.border = "thin solid red";
            style.color = "red";
            style.backgroundImage = "linear-gradinachrichten ent(pink, transparent)";
        }
        return <Tab key={option} label={optionLabels[option] ? optionLabels[option] : option} style={style} />;
    }

    return (
        <Tabs onChange={handleTabChange} value={options.indexOf(value)}>
            {options.map((option) => createOption(option))}
        </Tabs>
    );
}

EATabs.propTypes = {
    options: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
};

export default EATabs;
